"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Card } from '@/components/ui/Card';
import { Star, Quote } from 'lucide-react';
export default function Testimonials() {
  const $ = _c(64);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    isVisible
  } = useScrollAnimation(t0);
  let T0;
  let companyTestimonials;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== isVisible || $[2] !== ref) {
    const testimonials = [{
      name: "Sarah Johnson",
      role: "Frontend Developer",
      company: "Tech Corp",
      image: "SJ",
      rating: 5,
      text: "Learn2Link transformed my career! I went from a complete beginner to landing my dream internship in just 4 months. The competitive leaderboards kept me motivated, and the auto-matching feature was incredible.",
      course: "React Development Bootcamp"
    }, {
      name: "Michael Chen",
      role: "Data Analyst",
      company: "DataViz Inc",
      image: "MC",
      rating: 5,
      text: "The live interactive sessions were game-changers. Getting matched to a company that perfectly aligned with my skills saved me months of job searching. Highly recommend!",
      course: "Data Science Professional"
    }, {
      name: "Emily Rodriguez",
      role: "UX Designer",
      company: "Creative Studio",
      image: "ER",
      rating: 5,
      text: "I loved the competitive aspect! Seeing my rank improve motivated me to keep learning. The certificate I earned opened so many doors. Now I'm working on real projects!",
      course: "UX/UI Design Master"
    }, {
      name: "David Kim",
      role: "Backend Engineer",
      company: "CloudTech Solutions",
      image: "DK",
      rating: 5,
      text: "The quality of courses is exceptional, and the automatic matching system is genius. I got matched to 3 different opportunities and chose the best one. Life-changing platform!",
      course: "Python & Django Developer"
    }, {
      name: "Jessica Taylor",
      role: "Marketing Manager",
      company: "Growth Labs",
      image: "JT",
      rating: 5,
      text: "As someone switching careers, Learn2Link made the transition smooth. The combination of learning, competing, and getting matched is brilliant. Worth every penny!",
      course: "Digital Marketing Pro"
    }, {
      name: "Alex Martinez",
      role: "Mobile Developer",
      company: "App Innovations",
      image: "AM",
      rating: 5,
      text: "The platform's feedback system is excellent. When a company reported a skill gap, I was able to improve and get re-matched. This accountability makes the platform trustworthy.",
      course: "React Native Development"
    }];
    let t13;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = [{
        name: "Jennifer Lee",
        role: "HR Director",
        company: "TechStart Inc",
        image: "JL",
        text: "Learn2Link has become our go-to platform for hiring. The students come pre-vetted with verified skills, and the matching algorithm saves us countless hours in recruitment."
      }, {
        name: "Robert Williams",
        role: "CTO",
        company: "Innovation Labs",
        image: "RW",
        text: "We've hired 15 interns through Learn2Link this year alone. The quality assurance system ensures we get the best talent, and the reporting feature helps maintain high standards."
      }];
      $[17] = t13;
    } else {
      t13 = $[17];
    }
    companyTestimonials = t13;
    t10 = "feedbacks";
    t11 = "py-20 md:py-32 bg-white";
    t12 = ref as React.RefObject<HTMLElement>;
    t8 = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
    let t14;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {
        opacity: 0,
        y: 20
      };
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    let t15;
    if ($[19] !== isVisible) {
      t15 = isVisible ? {
        opacity: 1,
        y: 0
      } : {};
      $[19] = isVisible;
      $[20] = t15;
    } else {
      t15 = $[20];
    }
    let t16;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        duration: 0.6
      };
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    let t17;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-semibold mb-4"><Star className="w-4 h-4 fill-yellow-700" /><span>Trusted by Thousands</span></div>;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    let t18;
    let t19;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Success Stories from<span className="block bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">{"Students & Companies"}</span></h2>;
      t19 = <p className="text-xl text-gray-600 max-w-3xl mx-auto">See how Learn2Link is transforming careers and helping companies find top talent</p>;
      $[23] = t18;
      $[24] = t19;
    } else {
      t18 = $[23];
      t19 = $[24];
    }
    if ($[25] !== t15) {
      t9 = <motion.div initial={t14} animate={t15} transition={t16} className="text-center mb-16">{t17}{t18}{t19}</motion.div>;
      $[25] = t15;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    T0 = motion.div;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        opacity: 0,
        y: 20
      };
      $[27] = t3;
    } else {
      t3 = $[27];
    }
    if ($[28] !== isVisible) {
      t4 = isVisible ? {
        opacity: 1,
        y: 0
      } : {};
      $[28] = isVisible;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        duration: 0.6,
        delay: 0.2
      };
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    t6 = "mb-12";
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">From Our Students</h3>;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    t1 = "grid md:grid-cols-2 lg:grid-cols-3 gap-6";
    t2 = testimonials.map((testimonial, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 20
    }} animate={isVisible ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6,
      delay: 0.3 + index * 0.1
    }}><Card hover={true} className="h-full relative"><div className="absolute top-4 right-4 text-blue-200"><Quote className="w-8 h-8" /></div><div className="p-6"><div className="flex gap-1 mb-4">{[...Array(testimonial.rating)].map(_temp)}</div><p className="text-gray-700 mb-6 leading-relaxed">"{testimonial.text}"</p><div className="mb-4 inline-block bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">{testimonial.course}</div><div className="flex items-center gap-3 mt-4 pt-4 border-t border-gray-200"><div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center text-white font-bold shadow-lg">{testimonial.image}</div><div><div className="font-bold text-gray-900">{testimonial.name}</div><div className="text-sm text-gray-600">{testimonial.role} at {testimonial.company}</div></div></div></div></Card></motion.div>);
    $[1] = isVisible;
    $[2] = ref;
    $[3] = T0;
    $[4] = companyTestimonials;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[3];
    companyTestimonials = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t13;
  if ($[32] !== t1 || $[33] !== t2) {
    t13 = <div className={t1}>{t2}</div>;
    $[32] = t1;
    $[33] = t2;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== T0 || $[36] !== t13 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7) {
    t14 = <T0 initial={t3} animate={t4} transition={t5} className={t6}>{t7}{t13}</T0>;
    $[35] = T0;
    $[36] = t13;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 0,
      y: 20
    };
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== isVisible) {
    t16 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[44] = isVisible;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.6,
      delay: 0.8
    };
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">From Our Partner Companies</h3>;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== companyTestimonials || $[49] !== isVisible) {
    t19 = <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">{companyTestimonials.map((testimonial_0, index_0) => <motion.div key={index_0} initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.9 + index_0 * 0.1
      }}><Card className="bg-gradient-to-br from-indigo-50 to-purple-50 border-indigo-200"><div className="p-8"><Quote className="w-10 h-10 text-indigo-300 mb-4" /><p className="text-gray-700 mb-6 leading-relaxed text-lg">"{testimonial_0.text}"</p><div className="flex items-center gap-3"><div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold shadow-lg">{testimonial_0.image}</div><div><div className="font-bold text-gray-900">{testimonial_0.name}</div><div className="text-sm text-gray-600">{testimonial_0.role}, {testimonial_0.company}</div></div></div></div></Card></motion.div>)}</div>;
    $[48] = companyTestimonials;
    $[49] = isVisible;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t16 || $[52] !== t19) {
    t20 = <motion.div initial={t15} animate={t16} transition={t17} className="mt-20">{t18}{t19}</motion.div>;
    $[51] = t16;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== t14 || $[55] !== t20 || $[56] !== t8 || $[57] !== t9) {
    t21 = <div className={t8}>{t9}{t14}{t20}</div>;
    $[54] = t14;
    $[55] = t20;
    $[56] = t8;
    $[57] = t9;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== t21) {
    t22 = <section id={t10} className={t11} ref={t12}>{t21}</section>;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = t21;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  return t22;
}
function _temp(_, i) {
  return <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />;
}